import { z } from 'zod';

import type { CreateUserRequest, CreateUserResponse } from './create-user.dto.js';
import { userStatusValues } from './user.dto.js';

export const CreateUserRequestSchema: z.ZodType<CreateUserRequest> = z.object({
  email: z.string().trim().pipe(z.email()),
  password: z.string().min(8),
});

export const CreateUserResponseSchema: z.ZodType<CreateUserResponse> = z.object({
  id: z.uuid(),
  email: z.string().trim().pipe(z.email()),
  status: z.enum(userStatusValues),
  createdAt: z.iso.datetime(),
});
